import dayjs from 'dayjs';

import { Disk } from '@typings';
import { as, getFormattedMemory, noop } from '@utils';

import { Button, Modal, Render } from '@components';
import { Layout } from '@components/Layouts';
import { DrawerDetailsItem } from '@components/Ui';

import { DeleteDiskModal } from './Modals';

type Props = {
  disk?: Disk;
  resetDiskId?: () => void;
  getDisks: () => Promise<void>;
};

export const DiskDetails = ({ disk, getDisks, resetDiskId = noop }: Props) => {
  const { id, name, uri, createdAt, status, owner, storage, lifeSpan } =
    as.o<Disk>(disk);
  const formattedDate = dayjs(createdAt).format('L');

  const getFormattedLifespan = () => {
    const minutes = Math.ceil((lifeSpan ?? 0) / 60);
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor((minutes % 1440) / 60);
    const remainingMinutes = minutes % 60;

    const timeParts = [];

    if (days > 0) {
      timeParts.push(`${days}d`);
    }

    if (hours > 0) {
      timeParts.push(`${hours}h`);
    }

    if (remainingMinutes > 0) {
      timeParts.push(`${remainingMinutes}m`);
    }

    return timeParts.join(' ');
  };

  return (
    <Layout.ContentDrawer
      className="flex flex-col gap-6"
      containerClassName="w-[420px]"
      title={name ?? id}
      onClose={resetDiskId}
      show={!!id}
    >
      <DrawerDetailsItem title="ID" text={id} />
      <Render if={uri}>
        <DrawerDetailsItem title="URI" text={uri} />
      </Render>
      <DrawerDetailsItem title="Status" text={status} />
      <DrawerDetailsItem title="Owner" text={owner} />
      <DrawerDetailsItem title="Storage" text={getFormattedMemory(storage)} />
      <Render if={lifeSpan}>
        <DrawerDetailsItem title="Lifespan" text={getFormattedLifespan()} />
      </Render>
      <DrawerDetailsItem title="Created" text={formattedDate} />
      <div className="flex gap-4">
        <Modal
          content={
            <DeleteDiskModal id={id} name={name ?? id} getDisks={getDisks} />
          }
        >
          <Button variant="error" className="capitalize">
            Delete disk
          </Button>
        </Modal>
      </div>
    </Layout.ContentDrawer>
  );
};
